<div style="margin-bottom: 0.5rem">
  <span class="projectScopeHeader">Capability</span>
</div>
<div>
  <textarea
    [(ngModel)]="data.capabilityDetails.capabilities"
    [readonly]="readOnly"
    class="scopeDescriptionTextBox"
    maxlength="255"
  ></textarea>
</div>
<div>
  <span style="color: #696969; font-style: italic; margin-right: 0.5rem; float: right"
    >{{ capabilityLength() }} / 255 characters</span
  >
</div>
<div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
  <span class="projectScopeHeader">Detailed Description of Capability</span>
</div>
<div>
  <textarea
    [(ngModel)]="data.capabilityDetails.description"
    [readonly]="readOnly"
    class="scopeDescriptionTextBox"
    maxlength="255"
  ></textarea>
</div>
<div style="padding-bottom: 0.625rem">
  <span style="color: #696969; font-style: italic; margin-right: 0.5rem; float: right"
    >{{ descriptionLength() }} / 255 characters</span
  >
</div>
<div style="text-align: center; margin-top: 1rem">
  <div class="exitButton" style="margin-right: 1.25rem" (click)="cancelAndClose()">
    @if (!readOnly) {
      <span class="exitText">CANCEL</span>
    }
    @if (readOnly) {
      <span class="exitText">EXIT</span>
    }
  </div>
  @if (!readOnly) {
    <div style="display: inline-block">
      <button class="confirmButton" (click)="closeDialog()">
        <span class="confirmText">SAVE</span>
      </button>
    </div>
  }
</div>
